import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReactionsResponse, ReactionType } from './interfaces/reactions.interface';

@Injectable({ providedIn: 'root' })
export class ReactionsService {
  private httpClient = inject(HttpClient);
  private baseUrl = environment.uiService.url;

  getReactions(postId: string): Observable<ReactionsResponse> {
    return this.httpClient.get<ReactionsResponse>(`${this.baseUrl}/post/reaction/${postId}`);
  }

  saveReaction(postId: string, userReaction: ReactionType): Observable<ReactionsResponse> {
    const body = {
      user_reaction: userReaction
    };

    return this.httpClient.post<ReactionsResponse>(`${this.baseUrl}/post/reaction/${postId}`, body);
  }

}
